const mutations = {
    BOOKING_LOADING: state => {
        state.bookingStatus = "loading";
    },
    BOOKING_SUCCESS: (state, booking) => {
        state.bookingStatus = "success";
        Vue.set(state, "bookingCart", booking.data);
    },
    MYBOOKING_SUCCESS: (state, mybookings) => {
        state.bookingStatus = "success";
        Vue.set(state, "mybookings", mybookings);
    },
    UPDATE_BOOKING_CART_RATE: (state, cart) => {
        state.bookingCart.rate_review = parseFloat(cart.rate_review);
    },
    UPDATE_BOOKING_CART: (state, cart) => {
        state.bookingCart = cart;
        Vue.set(state, "bookingCart", cart);
    },
    BOOKING_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.bookingStatus = "error";
        state.bookingErrors.record(errors);
    },
    CLEAR_PAYMENT_ERRORS: state => {
        state.paymentStatus = "";
        state.paymentErrors.clear();
    },
    PAYMENT_LOADING: state => {
        state.paymentStatus = "loading";
    },
    PAYMENT_SUCCESS: state => {
        state.paymentStatus = "success";
    },
    PAYMENT_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.paymentStatus = "error";
        state.paymentErrors.record(errors);
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
